import { React, useState } from "react";
import "../App.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Markup } from "interweave";
import { Icon } from "@iconify/react";
import { useUserAuth } from "../auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Home = () => {
	const { logOut, user, addNote, notes, deleteNote } = useUserAuth();
	const navigate = useNavigate();
	const handleLogout = async () => {
		try {
			await logOut();
			navigate("/login");
		} catch (error) {
			toast.error(error.message);
		}
	};

	function convert(txt) {
		var text_input;
		var output_html = "";
		var counter;
		text_input = txt;
		if (text_input.length > 0) {
			output_html += "<p>";
			for (counter = 0; counter < text_input.length; counter++) {
				switch (text_input[counter]) {
					case "\n":
						if (text_input[counter + 1] === "\n") {
							output_html += "</p>\n<p>";
							counter++;
						} else output_html += "<br>";
						break;

					case " ":
						if (text_input[counter - 1] !== " " && text_input[counter - 1] !== "\t") output_html += " ";
						break;

					case "\t":
						if (text_input[counter - 1] !== "\t") output_html += " ";
						break;

					case "&":
						output_html += "&amp;";
						break;

					case '"':
						output_html += "&quot;";
						break;

					case ">":
						output_html += "&gt;";
						break;

					case "<":
						output_html += "&lt;";
						break;

					default:
						output_html += text_input[counter];
				}
			}
			output_html += "</p>";
		}
		return output_html;
	}

	function copyText(entryText) {
		navigator.clipboard.writeText(entryText);
		toast.success("Content is successfully copied.");
	}

	const [txt, setTxt] = useState("");

	const handleAdd = async (e) => {
		if (txt.trim().length != 0) {
			const note = txt;
			setTxt("");
			await addNote(note);
		} else {
			setTxt("");
		}
	};

	const Delete = (id) => (
		<>
			<p style={{ fontSize: "18px", fontFamily: "Fredoka" }}>Are you sure you want to delete?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", fontFamily: "Fredoka", padding: "6px", background: "#1da1f2", color: "#ffffff" }} onClick={() => deleteNote(id.id)}>
				Delete
			</button>
		</>
	);
	const Logout = () => (
		<>
			<p style={{ fontSize: "18px", color: "var(--clr-txt)", fontFamily: "Fredoka" }}>Are you sure you want to logout {user.displayName}?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", padding: "6px", color: "#ffffff", fontFamily: "Fredoka", background: "#1da1f2" }} onClick={() => handleLogout()}>
				Yes
			</button>
		</>
	);

	let notesContent = [];
	for (let i = 0; i < notes.length; i++) {
		let notemsg = convert(notes[i].note);
		notesContent.push(
			<motion.div layout key={notes[i].id} className="item">
				<motion.span className="note" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.05 }} id={notes[i].id}>
					<Markup className="notemsg" content={notemsg} />
					<div className="listbtns">
						<Icon
							onClick={() => {
								copyText(notes[i].note);
							}}
							className="copyicon"
							icon="akar-icons:copy"
						/>
						<Icon className="delicon" onClick={() => toast(<Delete id={notes[i].id} />)} icon="ant-design:minus-circle-twotone" />
					</div>
				</motion.span>
			</motion.div>
		);
	}

	return (
		<>
			<input type="checkbox" id="check" />
			<div className="route-icons">
				<Link className="route-icon" to="/">
					<Icon icon="noto-v1:notebook" />
				</Link>
				<Link className="route-icon" to="/passwords">
					<Icon icon="logos:keycdn-icon" />
				</Link>
				<Link className="route-icon" to="/files">
					<Icon icon="vscode-icons:folder-type-images-opened" />
				</Link>
			</div>

			<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ alignItems: "flex-start", backgroundImage: `url("https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/notes.svg?alt=media")`, backgroundSize: "500px" }}>
				{user != null && (
					<>
						<span className="logoutIcon">
							<Icon onClick={() => toast(<Logout />)} icon="majesticons:logout-half-circle" />
						</span>
						<div id="notes" style={{ marginTop: "100px", marginBottom: "125px" }} className="notes">
							<div id="items" className="items">
								{notesContent}
							</div>
							{notes.length === 0 && <div className="msgText">Your notes is completely encrypted and is only visible to you.</div>}
							<input type="hidden" className="deleteID" id="deleteID" value="" />
							<div className="inputdiv-container">
								<div className="inputdiv" id="inputdiv">
									<textarea id="txtinput" value={txt} onChange={(e) => setTxt(e.target.value)} style={{ overflow: "hidden" }} placeholder="Enter something..."></textarea>
									<div id="addbtn" className="addbtn">
										<span className="addicon">
											<Icon onClick={handleAdd} icon="fluent:add-circle-16-filled" />
										</span>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</motion.section>
		</>
	);
};

export default Home;
